var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 768,
    viewBox: "0 0 671 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_455_4204)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 671,
    height: 768,
    fill: "#111522"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 674,
    height: 768,
    fill: "#111522"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    filter: "url(#filter0_f_455_4204)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-67.6056 22.0997C-39.8921 -4.36758 8.13408 -21.2754 50.1974 -19.4799C87.1806 -17.9013 96.9471 13.3365 122.442 30.2119C143.397 44.0819 177.687 48.479 184.222 69.2313C191.504 92.3588 180.216 119.469 157.141 140.41C133.884 161.516 98.8024 172.556 63.9249 178.404C27.8786 184.448 -9.6782 186.086 -37.5979 173.062C-66.6944 159.489 -79.3818 134.935 -84.5044 109.165C-90.2404 80.3079 -94.7369 48.0111 -67.6056 22.0997Z",
    fill: "url(#paint0_linear_455_4204)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_455_4204)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_455_4204)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.936 679.418C530.225 662.069 620.118 648.948 687.162 668.125C759.252 688.744 803.645 732.427 796.282 777.91C789.475 819.959 719.864 855.116 652.373 883.021C601.317 904.132 537.957 900.017 477.513 909.712C400.876 922.005 321.539 964.092 256.814 946.469C191.807 928.77 197.194 877.113 208.81 836.553C218.291 803.446 270.274 778.557 312.766 751.094C355.228 723.65 390.784 692.97 451.936 679.418Z",
    fill: "url(#paint1_linear_455_4204)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_455_4204)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-51.9077 727.064C-3.53365 680.619 83.0806 652.319 160.537 657.454C228.639 661.97 249.586 718.705 298.052 750.269C337.886 776.21 401.311 785.684 415.312 823.377C430.915 865.384 412.781 913.731 372.399 950.426C331.698 987.411 268.302 1005.72 204.783 1014.68C139.136 1023.95 70.289 1025.2 17.7393 1000.47C-37.0251 974.698 -62.6967 929.876 -74.5859 883.203C-87.8992 830.94 -99.2657 772.534 -51.9077 727.064Z",
    fill: "url(#paint2_linear_455_4204)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_455_4204",
    x: -241.849,
    y: -172.61,
    width: 581.266,
    height: 508.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 76.5,
    result: "effect1_foregroundBlur_455_4204"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_455_4204",
    x: 29.6436,
    y: 486.655,
    width: 939.433,
    height: 636.065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 86,
    result: "effect1_foregroundBlur_455_4204"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_455_4204",
    x: -325.203,
    y: 417.856,
    width: 985.078,
    height: 841.951,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 119.5,
    result: "effect1_foregroundBlur_455_4204"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_455_4204",
    x1: 5.60566,
    y1: -13.4229,
    x2: 33.959,
    y2: 200.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#821BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_455_4204",
    x1: 783.118,
    y1: 639,
    x2: 647.693,
    y2: 1105.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#821BFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C59FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_455_4204",
    x1: 260.044,
    y1: 1009.45,
    x2: 148.709,
    y2: 633.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_455_4204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 671,
    height: 768,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_455_4204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 671,
    height: 424,
    fill: "white",
    transform: "translate(0 344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.3004065c9475ffd9b9a15a5c5262c9f5.svg";
export { ForwardRef as ReactComponent };